module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid grid-cols-12"
  }, [_c('div', {
    staticClass: "col-span-12 intro-y"
  }, [(!_vm.all) ? _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.changeReport(true)
      }
    }
  }, [_vm._v("\n      Ver " + _vm._s(_vm.team_session == 1 ? 'todos los proyectos' : 'todas las cuenta') + "\n    ")]) : _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.changeReport(false)
      }
    }
  }, [_vm._v("\n      Ver solo " + _vm._s(_vm.team_session == 1 ? 'un proyecto' : 'una cuenta') + "\n    ")])]), _vm._v(" "), (!_vm.all) ? _c('TasksMonthsAccount') : _c('TasksAccounts')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09d35084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/report/ReportTasks.vue
// module id = 408
// module chunks = 1